import { apiGetCampCart, apiGetCampCartAddonOptions, apiAddCampCartAddon, apiDeleteCampCart } from '@/api/API';

const cachedCount = () => {
    try {
        return Number(localStorage.getItem('campCartCachedCount')) || 0;
    } catch {
        return 0;
    }
};

export default {
    namespaced: true,
    state: {
        items: [],
        addonOptions: [],
        loading: false,
        selectedIds: [],
        loaded: false,
        cachedCount: cachedCount(),
    },
    mutations: {
        setItems(state, items) {
            state.items = items;
            state.loaded = true;
            state.cachedCount = items.length;
            try {
                localStorage.setItem('campCartCachedCount', String(items.length));
            } catch {
                // ignore storage errors
            }
        },
        setAddonOptions(state, items) {
            state.addonOptions = items;
        },
        setLoading(state, val) {
            state.loading = val;
        },
        setLoaded(state, val) {
            state.loaded = val;
        },
        setSelectedIds(state, ids) {
            state.selectedIds = ids;
        },
        // checkout 頁 preview/送出時後端已剪除加購 CampCart，這裡只同步移除本機快取項目，
        // 不動 selectedIds（主梯次的報名成員選取狀態），避免覆蓋使用者在購物車頁的選擇。
        removeItems(state, ids) {
            const idSet = new Set(ids);
            state.items = state.items.filter((i) => !idSet.has(i.Id));
        },
    },
    actions: {
        async fetchCart({ commit, state }) {
            if (state.loading) return;

            commit('setLoading', true);
            try {
                const res = await apiGetCampCart();
                const items = Array.isArray(res.data) ? res.data : [];
                commit('setItems', items);
                commit('setSelectedIds', items.filter((i) => !i.IsCampAddon && !i.HasConflict && !i.IsSoldOut).map((i) => i.Id));

                try {
                    const addonRes = await apiGetCampCartAddonOptions();
                    commit('setAddonOptions', addonRes.data || []);
                } catch {
                    commit('setAddonOptions', []);
                }
            } catch {
                // 讀取失敗時保留目前的購物車快取數量，避免暫時性錯誤把角標數字閃成 0
                commit('setAddonOptions', []);
                commit('setSelectedIds', []);
            } finally {
                commit('setLoading', false);
            }
        },
        async removeItem({ dispatch }, id) {
            await apiDeleteCampCart(id);
            await dispatch('fetchCart');
        },
        async addAddon({ dispatch }, data) {
            await apiAddCampCartAddon(data);
            await dispatch('fetchCart');
        },
    },
    getters: {
        hasConflict: (state) => state.items.some((i) => i.HasConflict),
        hasSoldOut: (state) => state.items.some((i) => i.IsSoldOut),
        totalPrice: (state) => state.items.reduce((sum, i) => sum + (i.TotalPrice || 0), 0),
        selectedCartIds: (state) => {
            const selectedSourceIds = new Set(state.selectedIds);
            return state.items
                .filter((i) => selectedSourceIds.has(i.Id) || (i.IsCampAddon && selectedSourceIds.has(i.SourceCampCartId)))
                .map((i) => i.Id);
        },
        selectedTotalPrice: (state, getters) =>
            state.items
                .filter((i) => getters.selectedCartIds.includes(i.Id))
                .reduce((sum, i) => sum + (i.TotalPrice || 0), 0),
        mainItems: (state) => state.items.filter((i) => !i.IsCampAddon),
        totalCount: (state) => (state.loaded ? state.items.length : state.cachedCount),
        addonsBySourceCartId: (state) =>
            state.items
                .filter((i) => i.IsCampAddon && i.SourceCampCartId)
                .reduce((map, item) => {
                    if (!map[item.SourceCampCartId]) map[item.SourceCampCartId] = [];
                    map[item.SourceCampCartId].push(item);
                    return map;
                }, {}),
        addonOptionsByCartId: (state) =>
            state.addonOptions.reduce((map, group) => {
                map[group.SourceCartId] = group.Options || [];
                return map;
            }, {}),
    },
};
